export default __webpack_public_path__ + "static/media/img-3527.9b0ff20a.jpeg";